<template>
  <div class="gallery-products">
    <GalleryGrid
      :images="imagesGrid"
      :columns="columns"
    >
      <ProductSlide
        v-for="(product, index) in products"
        :key="index"
        class="gallery__slide"
        :product="product"
      />
    </GalleryGrid>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { TImageSize } from '~/types/common';
  import type {
    IContentGalleryProducts,
    TGalleryProductItem,
  } from '~/types/components/GalleryProducts';
  import GalleryGrid from '~/components/Gallery/GalleryGrid.vue';
  import ProductSlide from '~/components/Gallery/ProductSlide.vue';

  export default defineNuxtComponent({
    name: 'GalleryProducts',

    components: {
      GalleryGrid,
      ProductSlide,
    },

    props: {
      elem: {
        type: Object as PropType<IContentGalleryProducts>,
        required: true,
      },
    },

    computed: {
      products(): TGalleryProductItem[] {
        return this.elem.attributes.items;
      },

      columns(): number {
        return this.elem.attributes.columns;
      },

      imagesGrid(): Array<TImageSize[]> {
        return this.products.map((product: TGalleryProductItem) => product.image.sizes);
      },
    },
  });
</script>
